import { APP_PERMISSIONS } from '@exam-management/permissions';
import type { DataGridProps, GridColDef } from '@shared/components';
import { WithPermission } from '@shared/permissions';

import type { SelectUsersCountBaseProps } from '../../components';
import { defaultDataGridState } from '../../constants';
import {
  UserListProvider,
  UserListStateProvider,
  type UserListDataGridParams,
} from '../../provider';
import {
  type OnSelectUserCallback,
  UserListParamsVariants,
  type UserListOptions,
  type UserListVariants,
} from '../../types';
import { QBankStructureMemberList } from '../qbank-structure-members-list';
import { UserManagementList } from '../user-management-list/user-management-list';

export interface UserListProps {
  variant: UserListVariants;
  moreColumns?: GridColDef[];
  DataGridProps?: Omit<DataGridProps, 'rows' | 'columns'>;
  SelectUsersCountProps?: SelectUsersCountBaseProps;
  paramsVariant?: UserListParamsVariants;
  options?: UserListOptions;
  initialDataGridParams?: UserListDataGridParams;
  shouldInvertFilter?: boolean;
  onSelectUser?: OnSelectUserCallback;
}

export type OmittedUserListProps = Omit<UserListProps, 'variant'>;

export function UserList(props: Readonly<UserListProps>) {
  const {
    variant,
    paramsVariant = UserListParamsVariants.SEARCH_QUERY_PARAMS,
    initialDataGridParams = defaultDataGridState,
    onSelectUser,
    DataGridProps = { ...props.DataGridProps, sx: { minHeight: '100%' } },
    ...restProps
  } = props;

  let children = null;

  switch (variant) {
    case 'USER_MANAGEMENT':
      children = <UserManagementList {...restProps} DataGridProps={DataGridProps} />;
      break;
    case 'QBANK_STRUCTURE_MEMBERS':
      children = <QBankStructureMemberList {...restProps} DataGridProps={DataGridProps} />;
      break;
  }
  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.SETTING.USER.VIEW}>
      {paramsVariant == UserListParamsVariants.SEARCH_QUERY_PARAMS ? (
        <UserListProvider initialDataGridParams={initialDataGridParams} onSelectUser={onSelectUser}>
          {children}
        </UserListProvider>
      ) : (
        <UserListStateProvider
          initialDataGridParams={initialDataGridParams}
          onSelectUser={onSelectUser}
        >
          {children}
        </UserListStateProvider>
      )}
    </WithPermission>
  );
}
